<template lang="html">
    <div class="z-dates" v-bind:class="classes" ref="component">
        <label v-if="label" v-html="label">
            <span v-if="required"> *</span>
        </label>

        <div class="z-dates__calendar">
            <header class="z-dates__calendar__header">
                <z-icon-button v-bind:icon="['fa', 'chevron-left']" v-on:click="setPrevMonth"></z-icon-button>
                <span class="z-dates__calendar__header__day">{{ moment(currentDate).format('MMMM YYYY') }}</span>
                <z-icon-button v-bind:icon="['fa', 'chevron-right']" v-on:click="setNextMonth"></z-icon-button>
            </header>
            <div class="z-dates__calendar__body">
                <div class="z-dates__calendar__week">
                    <div
                        class="z-dates__calendar__week-day"
                        v-for="(day, i) in weekDays"
                        :key="`z-dates-week-day-${id}-${i}`"
                        v-html="day"
                    ></div>
                </div>

                <div class="z-dates__calendar__month">
                    <div
                        v-for="(day, i) in days"
                        :key="`z-dates-day-${day.date}-${i}`"
                        :class="{
                            'z-dates__calendar__month__day': true,
                            'current': day.isCurrentMonth,
                            'notcurrent': !day.isCurrentMonth,
                            'selected': inValue(day.date)
                        }"
                        @click="onDateClick(day)"
                    >{{ moment(day.date).format('D') }}</div>
                </div>
            </div>
            <footer class="z-dates__calendar__footer"></footer>
        </div>
        
        <span v-if="$props.error" class="z-error">{{$props.error}}</span>
    </div>
</template>
<script>
    import ZIconButton from '@/components/ZIconButton.vue';
    import ZInput from '@/components/ZInput';
    import date from '@/mixins/date';

    export default {
        name: 'z-dates',
        components: {ZInput, ZIconButton},
        mixins: [date],
        props: {
            value: {
                type: Array,
                default: () => []
            },
            error: {
                type: String,
                default: null
            },
            label: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            dirty: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                isDirty: false,
                val: [],
                calendar: null,
                calendarClickListener: null,
                componentClickListener: null,
            }
        },
        created() {
            this.val = Object.assign([], this.$props.value);
        },
        watch: {
            'val'(n) {
                this.$emit('input', n);
            },
            'value'(n, o) {
                if (JSON.stringify(n) === JSON.stringify(o)) return;
                this.val = Object.assign([], n);
            },
            '$props.dirty'(val) {
                if (val && this.isDirty !== val) this.emitDirty();
            },
            'currentDate'(n, o) {
                this.emits(n, o);
            }
        },
        computed: {
            id() {
                return this._uid
            },
            classes() {
                return {
                    'inline':    this.inline,
                    'has-error': this.error && this.error.length,
                    'is-dirty':  this.isDirty,
                }
            }
        },
        methods: {
            onDateClick(day) {
                if (this.$props.disabled) return;
                const i = this.val.indexOf(day.date);
                if (i+1) this.val.splice(i, 1)
                else this.val.push(day.date)

                if (this.inValue(day.date)) this.$emit('check', day.momentDate)
                else this.$emit('uncheck', day.momentDate)
            },
            inValue(date) {
                return !!(this.val.indexOf(date)+1)
            },
            emitDirty() {
                this.isDirty = true;
                this.$emit('update:dirty', this.isDirty);
            },
            onChange() {
                this.emitDirty();
            },
            emits(n, o) {
                if (n === o) return;
                const
                    nDay   = n ? n.format('DD') : null,
                    nMonth = n ? n.format('MM') : null,
                    nYear  = n ? n.format('Y')  : null,
                    oDay   = o ? o.format('DD') : null,
                    oMonth = o ? o.format('MM') : null,
                    oYear  = o ? o.format('Y')  : null;
                
                if (nDay   !== oDay)   this.$emit('change-day', n);
                if (nMonth !== oMonth) this.$emit('change-month', n);
                if (nYear  !== oYear)  this.$emit('change-year', n);
            }
        }    
    }
</script>
<style lang="sass">
    .z-dates
        margin: 4px 0 10px 0
        width: 100%
        .z-error
            display: block
            height: auto
            min-height: 15px
            font-size: 11px
            line-height: 11px
            padding: 8px 0 0
            color: #ff1744
        label
            display: block
            color: rgba(0, 0, 0, 0.54)
            font-size: 12px
            font-weight: 500
            line-height: 12px
            transition: .4s cubic-bezier(.25,.8,.25,1)
            transition-duration: .3s
            z-index: 5
            resize: none
            margin-bottom: 10px
            span
                color: #D66565

        .z-dates__calendar
            font-size: 12px
            box-shadow: 0 6px 12px rgba(0,0,0,.175)
            padding: 6px
            min-width: 250px
            max-width: 1000px
        .z-dates__calendar__header
            display: flex
            align-items: center
            justify-content: space-between
            font-size: 14px
        .z-dates__calendar__body
        .z-dates__calendar__week
            display: flex
            align-items: center
            justify-content: center
        .z-dates__calendar__week-day
            display: flex
            align-items: center
            justify-content: center
            width: calc(100% / 7)
            min-width: 32px
            min-height: 32px
        .z-dates__calendar__month
            display: flex
            align-items: center
            justify-content: center
            flex-wrap: wrap
        .z-dates__calendar__month__day
            display: flex
            align-items: center
            justify-content: center
            width: calc(100% / 7)
            min-width: 32px
            min-height: 32px
            cursor: pointer
            &.current
            &.notcurrent
                color: #ccc
            &.selected
                background-color: #E5F3FE
            &:hover
                background: var(--color-secondary-200)                
        .z-dates__calendar__footer

    .z-dates.is-dirty
        label
            color: #2196f3
</style>


// WEBPACK FOOTER //
// ZDates.vue?cda206fe